export default [
    {
        path: '/identity-providers',
        name: 'identity-providers',
        component: () => import('../../pages/providers/IndexPage.vue'),
        meta: {
            title: 'Identity Providers',
            requiresAuth: true,
        },
    },
    {
        path: '/identity-providers/:id',
        name: 'identity-providers-detail',
        component: () => import('../../pages/providers/IndexPage.vue'),
        meta: {
            title: 'Identity Provider Detail',
            requiresAuth: true,
        },
    },
]
